import * as PRIVILEGE from '@shared/constants/privilege'
import { MenuItemType } from '@/layout/types'
import { checkAndPermission } from '@/utils/permission'

export const menuTree: MenuItemType[] = [
  {
    id: 'overview',
    system: 'TARGET',
    url: '/siteReport/overview',
    roles: [PRIVILEGE.mktSiteStatisticView, PRIVILEGE.mktSiteMonitorView],
  },
  {
    id: 'interact',
    system: 'CMS',
    url: '/interact',
    subMenu: [
      {
        id: 'inquiryManagement',
        system: 'CMS',
        url: '/interact/inquiry',
      },
      {
        id: 'inquiryReport',
        system: 'CMS',
        url: '/interact/report',
      },
      {
        id: 'inquirySetting',
        system: 'CMS',
        subMenu: [
          {
            id: 'mailInquirySetting',
            system: 'CMS',
            url: '/interact/mail-setting',
          },
          {
            id: 'inquiryNotification',
            system: 'CMS',
            url: '/interact/notification/receiver',
          },
        ],
      },
      {
        id: 'inquiryRecycle',
        system: 'CMS',
        url: '/interact/recycle',
      },
    ],
  },
  {
    id: 'liveChat',
    system: 'TALK',
    url: '/live-chat',
    subMenu: [
      { id: 'currentSession', system: 'TALK', url: '/live-chat' },
      {
        id: 'historicalSession',
        system: 'TALK',
        url: '/liveChat/history/management',
        roles: [PRIVILEGE.mktConversationHistoryView],
      },
      {
        id: 'sessionSetting',
        system: 'CMS',
        url: '/liveChat/setting',
      },
    ],
  },
  {
    id: 'googleAds',
    system: 'TARGET',
    url: '/googleAds',
    subMenu: [
      {
        id: 'adReport',
        system: 'TARGET',
        url: '/googleAds/report',
        roles: {
          value: [PRIVILEGE.mktGoogleAdsView],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'adAccountManage',
        system: 'TARGET',
        url: '/googleAds/accountManage/account',
        roles: [PRIVILEGE.mktSettingGoogleAdsAccount, PRIVILEGE.mktSettingGoogleAdsTrack],
      },
    ],
  },
  {
    id: 'content',
    system: 'CMS',
    url: '/content',
    roles: {
      value: [PRIVILEGE.mktFunctionalContent],
      handle: (value, list, user) => checkAndPermission(value, { list, user }),
    },
    subMenu: [
      {
        id: 'product',
        system: 'CMS',
        url: '/content/product',
        roles: {
          value: [PRIVILEGE.mktFunctionalProduct],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
        subMenu: [
          {
            id: 'productList',
            system: 'CMS',
            url: '/content/product/list',
            roles: {
              value: [PRIVILEGE.mktProductView],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
          {
            id: 'productGroup',
            system: 'CMS',
            url: '/content/product/group',
            roles: {
              value: [PRIVILEGE.mktProductGroup],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
          {
            id: 'productSetting',
            system: 'CMS',
            url: '/content/product/setting',
            roles: {
              value: [PRIVILEGE.mktProductSetting],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
          {
            id: 'productImport',
            system: 'CMS',
            url: '/content/product/import',
            roles: {
              value: [PRIVILEGE.mktProductSyncing],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
        ],
      },
      {
        id: 'article',
        system: 'CMS',
        url: '/content/article',
        subMenu: [
          {
            id: 'articleList',
            system: 'CMS',
            url: '/content/article-list',
            roles: {
              value: [PRIVILEGE.mktArticleView],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
          {
            id: 'articleGroup',
            system: 'CMS',
            url: '/content/article-group',
            roles: {
              value: [PRIVILEGE.mktArticleGroup],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
        ],
      },
      {
        id: 'atlas',
        system: 'CMS',
        url: '/content/atlas',
        subMenu: [
          {
            id: 'atlasList',
            system: 'CMS',
            url: '/content/atlas-list',
            roles: {
              value: [PRIVILEGE.mktImage_collectionView],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
          {
            id: 'atlasGroup',
            system: 'CMS',
            url: '/content/atlas-group',
            roles: {
              value: [PRIVILEGE.mktImage_collectionGroup],
              handle: (value, list, user) => checkAndPermission(value, { list, user }),
            },
          },
        ],
      },
      {
        id: 'videoList',
        system: 'CMS',
        url: '/content/video-list',
        roles: {
          value: [PRIVILEGE.mktVideoView],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'downloadList',
        system: 'CMS',
        url: '/content/download-list',
        roles: {
          value: [PRIVILEGE.mktDownloadView],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'source',
        system: 'CMS',
        url: '/content/source',
        roles: {
          value: [PRIVILEGE.mktFunctionalSiteCustom],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
        subMenu: [
          {
            id: 'imageManagement',
            system: 'CMS',
            url: '/content/source/image',
          },
          {
            id: 'videoManagement',
            system: 'CMS',
            url: '/content/source/video',
          },
          {
            id: 'fileManagement',
            system: 'CMS',
            url: '/content/source/file',
          },
        ],
      },
      {
        id: 'contentRecycle',
        system: 'CMS',
        url: '/content/recycle',
        roles: {
          value: [PRIVILEGE.mktSettingRecycle],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
    ],
  },
  {
    id: 'siteSettings',
    system: 'CMS',
    url: '/siteSettings',
    subMenu: [
      {
        id: 'settingsTemplate',
        system: 'CMS',
        url: '/siteSettings/template/home',
        roles: {
          value: [PRIVILEGE.mktSiteManageTemplate],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsColumn',
        system: 'CMS',
        url: '/siteSettings/column',
        roles: {
          value: [PRIVILEGE.mktSiteManageSection],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsHome',
        system: 'CMS',
        url: '/siteSettings/home',
        roles: {
          value: [PRIVILEGE.mktSiteManageIndex],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'formManagement',
        system: 'CMS',
        url: '/siteSettings/form',
        roles: {
          value: [PRIVILEGE.mktFormView],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'subscribeManagement',
        system: 'CMS',
        url: '/siteSettings/subscribe',
        roles: {
          value: [PRIVILEGE.mktSubscriptionView],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsInfo',
        system: 'CMS',
        url: '/siteSettings/info/base',
        roles: {
          value: [PRIVILEGE.mktSiteManageInfo],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsDomain',
        system: 'CMS',
        url: '/siteSettings/domain',
        roles: {
          value: [PRIVILEGE.mktSiteManageDomain],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsLanguage',
        system: 'CMS',
        url: '/siteSettings/language',
        roles: {
          value: [PRIVILEGE.mktSiteManageLanguage],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'siteManagement',
        system: 'CMS',
        url: '/siteSettings/siteManagement/sitemap',
        roles: {
          value: [PRIVILEGE.mktSiteManageView],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsRecord',
        system: 'CMS',
        url: '/siteSettings/record',
        roles: {
          value: [PRIVILEGE.mktSettingOperateRecord],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
    ],
  },
  {
    id: 'settings',
    system: 'CMS',
    url: '/settings',
    subMenu: [
      {
        id: 'configsTracking',
        system: 'TARGET',
        url: '/settings/tracking',
        roles: {
          value: [PRIVILEGE.mktSettingSiteTrack],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'settingsRoles',
        system: 'CMS',
        url: '/settings/roles',
        roles: {
          value: [PRIVILEGE.mktSettingRoleManage],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'formSetting',
        system: 'CMS',
        url: '/settings/form',
        roles: {
          value: [PRIVILEGE.mktSettingCustomFormSetting],
          handle: (value, list, user) => checkAndPermission(value, { list, user }),
        },
      },
      {
        id: 'languageSetting',
        system: 'CMS',
        url: '/settings/language',
        roles: [PRIVILEGE.mktSettingI18n],
      },
    ],
  },
]
